import { useScrollReveal } from "../../../hooks/useScrollReveal";

const testimonials = [
  {
    quote:
      "Die Villa am Zürichsee war innerhalb von drei Wochen verkauft. Die digitale Markenwelt hat Käufer angesprochen, die wir über kein Standard-Portal je erreicht hätten.",
    name: "Marcus Züger",
    role: "Senior Partner",
    company: "Zürich Sotheby's International Realty",
    image:
      "https://public.readdy.ai/ai/img_res/c3ffadb3cba291472ec4f547e60130af.jpg",
  },
  {
    quote:
      "Das Branding-Konzept für unser Gstaad-Chalet war vom ersten Tag an ein Alleinstellungsmerkmal. Kein Vergleich zu Standardinseraten — unsere Klientel hat das sofort gespürt.",
    name: "Sophie Reinhardt",
    role: "Associate Director",
    company: "Christie\'s Real Estate Schweiz",
    image:
      "https://readdy.ai/api/search-image?query=professional-swiss-businesswoman-luxury-real-estate-director-portrait-neutral-background-elegant-professional-attire-editorial-photography-40s-confident&width=200&height=200&seq=tstm002&orientation=squarish",
  },
  {
    quote:
      "Unsere Klientel ist es gewohnt, höchste Qualität in jedem Detail zu erleben. SPDB Studio liefert genau das — auch im Digitalen. Präzision auf einem Level, das ich so noch nicht gesehen habe.",
    name: "Pierre-André Morin",
    role: "Managing Director",
    company: "Prestige Immobilier Genève",
    image:
      "https://readdy.ai/api/search-image?query=professional-french-swiss-businessman-luxury-real-estate-managing-director-portrait-elegant-refined-neutral-background-editorial-photography-45s&width=200&height=200&seq=tstm003&orientation=squarish",
  },
];

export default function TestimonialsSection() {
  const { ref, isVisible } = useScrollReveal(0.1);

  return (
    <section className="pt-12 pb-32 px-8 lg:px-16 bg-warm-white">
      <div className="max-w-screen-xl mx-auto">
        {/* Header */}
        <div
          ref={ref}
          className={`text-center mb-20 transition-all duration-800 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <p className="section-label mb-5">Kundenstimmen</p>
          <h2 className="section-title-lg mb-6">Was Makler sagen.</h2>
          <span className="gold-divider" />
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((t, i) => (
            <div
              key={t.name}
              className={`bg-white p-10 flex flex-col gap-8 transition-all duration-800 ${
                isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
              }`}
              style={{ transitionDelay: `${i * 150}ms` }}
            >
              {/* Quote mark */}
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-double-quotes-l text-gold text-3xl" />
              </div>

              {/* Quote text */}
              <p className="font-sans font-light text-text-secondary text-sm leading-relaxed flex-1 italic">
                &ldquo;{t.quote}&rdquo;
              </p>

              {/* Divider */}
              <div className="h-px bg-light-gray" />

              {/* Person */}
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={t.image}
                    alt={`${t.name}, ${t.role} bei ${t.company}`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <p className="font-sans font-medium text-text-primary text-sm">{t.name}</p>
                  <p className="font-sans font-light text-text-muted text-xs mt-0.5">{t.role}</p>
                  <p className="font-sans text-gold text-xs tracking-wide mt-0.5">{t.company}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
